import { render } from "./mythVsFactOne.vue?vue&type=template&id=173c8db0"
import script from "./mythVsFactOne.vue?vue&type=script&lang=js"
export * from "./mythVsFactOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__